(() => {
  if (window.mcmThemeSearchInputReady) return;
  window.mcmThemeSearchInputReady = true;
  const bound = new WeakSet();
  function initialize() {
    const url = new URL(location.href);
    const query = url.searchParams.get('q');
    const label = url.searchParams.get('mcm_theme_term')?.trim();
    if (!query || query !== url.searchParams.get('mcm_theme_q') || !label || label.length > 160) return;
    document.querySelectorAll('[data-mcm-theme-search-input]').forEach(input => {
      if (bound.has(input) || input.value !== query || !input.form) return;
      bound.add(input);
      const form = input.form;
      let edited = false;
      input.value = label;
      input.addEventListener('input', () => { edited = true; });
      function submitTheme(event) {
        if (edited || input.value !== label) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        // Keep the original expanded query, filters and theme context together.
        const target = new URL(url);
        target.searchParams.delete('page');
        location.assign(target.href);
      }
      // Capture Enter before Horizon's component handles its own keydown.
      form.addEventListener('keydown', event => {
        if (event.target === input && event.key === 'Enter' && !event.isComposing) submitTheme(event);
      }, true);
      form.addEventListener('submit', submitTheme, true);
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
